module.exports = __webpack_public_path__ + "static/media/card-open-claw-es.c5fd687c.png";